import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { routeGuardCallbackId } from 'auth-types';

interface ROUTE_GUARD_STATE_TYPE {
  guardActive: boolean;
  guardMessage: string;
  unloadCallback: routeGuardCallbackId | undefined;
  criticalData: object | undefined;
}

const INITIAL_STATE: ROUTE_GUARD_STATE_TYPE = {
  guardActive: false,
  guardMessage: 'Unsaved changes are on this page. Are you sure you want to leave?',
  unloadCallback: undefined,
  criticalData: undefined,
};

const routeGuardSlice = createSlice({
  name: 'routeGuard',
  initialState: INITIAL_STATE,
  reducers: {
    setGuardActive(state: ROUTE_GUARD_STATE_TYPE, action: PayloadAction<boolean>) {
      state.guardActive = action.payload;
    },
    setGuardMessage(state: ROUTE_GUARD_STATE_TYPE, action: PayloadAction<string>) {
      state.guardMessage = action.payload;
    },
    setUnloadCallback(
      state: ROUTE_GUARD_STATE_TYPE,
      action: PayloadAction<routeGuardCallbackId | undefined>,
    ) {
      state.unloadCallback = action.payload;
    },
    setCriticalData(state: ROUTE_GUARD_STATE_TYPE, action: PayloadAction<object>) {
      state.criticalData = { ...action.payload };
    },
    resetGuard(state: ROUTE_GUARD_STATE_TYPE) {
      state.guardActive = INITIAL_STATE.guardActive;
      state.guardMessage = INITIAL_STATE.guardMessage;
      state.unloadCallback = INITIAL_STATE.unloadCallback;
      state.criticalData = INITIAL_STATE.criticalData;
    },
  },
});

export const { setGuardActive, setGuardMessage, setUnloadCallback, setCriticalData, resetGuard } =
  routeGuardSlice.actions;

export default routeGuardSlice.reducer;
